// extracted by mini-css-extract-plugin
module.exports = {"alert":"io","alertIcon":"ip","formContainer":"iq","formContainerInner":"ir","successIcon":"is","footer":"it","footerItem":"iu"};